<script lang="ts">
	import '../../../app.css';
	import { page } from '$app/stores';
	import GA from '$lib/components/Global/GA.svelte';
	import { onMount } from 'svelte';
	import Header from '$lib/components/Global/Header/Header.svelte';
	import Subheader from '$lib/components/Global/Subheader.svelte';
	import Footer from '$lib/components/Global/Footer.svelte';
	import Banner from '$lib/components/Global/Banner.svelte';
	import ContactRequest from '$lib/components/Global/ContactRequest.svelte';
	import domain from '$lib/stores/DomainStore';
	import { categories } from '$lib/stores/CategoryStore';
	import type { LayoutData } from './$types';
    import Pnm2025Takeover from '$lib/components/Global/Pnm2025Takeover.svelte';

	let loaded = false;
	let showBanner = false;
	let showButton = false;
   
	export let data: LayoutData;

	onMount(() => {
		categories.set(data.blogCategories);

		loaded = true;
		window.addEventListener('scroll', (event) => {
			if (window.pageYOffset > 500) {
				return (showButton = true);
			}
			return (showButton = false);
		});
	});

	let embed: boolean = false;
	$: embed = $page.data.embed || false;
</script>

<svelte:head>
	<meta name="facebook-domain-verification" content="0jymsz88gx01jbknovzc59uywa41hx" />
	<meta name="application-name" content="Poupança no Minuto" />
	<meta name="msapplication-TileColor" content="#018171" />
	<meta name="msapplication-TileImage" content="{$page.url.origin}/favicon.png" />

	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
	<link
		rel="preload"
		href="https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap"
		as="style"
	/>
	<link
		rel="stylesheet"
		href="https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap"
		as="style"
	/>
</svelte:head>

{#if loaded}
	<GA />
{/if}


<main class="flex h-full flex-col justify-stretch">
	{#if !embed && !$page.data.withoutHeader}
		<Header />
	{/if}
	{#if !embed && !$page.data.withoutSubheader}
		<Subheader {data} />
	{/if}
	<slot />
	{#if !embed && !$page.data.withoutFooter}
		<Footer />
	{/if}
</main>

<Pnm2025Takeover />




<!-- <Banner on:hideBanner={() => (showBanner = false)} /> -->
{#if showButton}
	<!-- <ContactRequest /> -->
{/if}

{#if !$page.data.embed}
	{@html /* html */ `
	<script type="text/javascript">
		var Tawk_API = Tawk_API || {},
			Tawk_LoadStart = new Date();

		Tawk_API.customStyle = {
			visibility: {
				desktop: {
					xOffset: 40,
					yOffset: 40
				},
				mobile: {
					xOffset: 10,
					yOffset: 50
				}
			}
		};

		window.OneSignal = window.OneSignal || [];

		window.addEventListener('appAfterLoad', function handleAfterLoad() {
			(function oneSignalIIFE() {
				var s1 = document.createElement('script'),
					s0 = document.getElementsByTagName('script')[0];
				s1.src = 'https://cdn.onesignal.com/sdks/OneSignalSDK.js';
				s0.parentNode.insertBefore(s1, s0);

				OneSignal.push(function () {
					OneSignal.init({
						appId: '${$domain?.OneSignalAppId}'
					});
				});
			})();

			(function tawkToIIFE() {
				var tawkToActive = ${$page.data.language == 'pt'};
				if (!tawkToActive) {
					return;
				}

				var s1 = document.createElement('script'),
					s0 = document.getElementsByTagName('script')[0];
				s1.async = true;
				s1.src = 'https://embed.tawk.to/663ce20507f59932ab3db3b8/1htet5q1n';
				s1.charset = 'UTF-8';
				s1.setAttribute('crossorigin', '*');
				s0.parentNode.insertBefore(s1, s0);
			})();

			(function brevoIIFE() {
				window.sib = {
					equeue: [],
					client_key: 'djp619ppmtl3ej2uby8oem3k'
				};
				window.sendinblue = {};
				for (var j = ['track', 'identify', 'trackLink', 'page'], i = 0; i < j.length; i++) {
					(function (k) {
						window.sendinblue[k] = function () {
							var arg = Array.prototype.slice.call(arguments);
							(
								window.sib[k] ||
								function () {
									var t = {};
									t[k] = arg;
									window.sib.equeue.push(t);
								}
							)(arg[0], arg[1], arg[2], arg[3]);
						};
					})(j[i]);
				}
				var n = document.createElement('script'),
					i = document.getElementsByTagName('script')[0];
				(n.type = 'text/javascript'),
					(n.id = 'sendinblue-js'),
					(n.async = !0),
					(n.src = 'https://sibautomation.com/sa.js?key=' + window.sib.client_key),
					i.parentNode.insertBefore(n, i),
					window.sendinblue.page();
			})();
		});
	</script>
`}
{/if}
